import { Component, OnInit } from '@angular/core';
import { User } from '../../../_models/user'
import { AuthenticationService } from 'src/app/_services';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  currentUser: User;
  constructor(
    private authenticationService : AuthenticationService
  ) {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
   }

  ngOnInit() {
  }

  logout(){
    this.authenticationService.logout();
  }

}
